import React, { useMemo, useRef } from 'react'
import UserMenu from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/UserMenu'
import TicketsCounter from 'components/Header/subcomponents/TicketsCounter'
import { Button, Grid, Icon, Tooltip } from 'gu-ui-kit'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import styles from 'components/Drawer/drawer.module.scss'
import { useSelector } from 'react-redux'
import { selectAppUser } from 'modules/App/store/selectors'
import { Link } from 'react-router-dom'
import FaqMenu from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/FaqMenu'
import DrawerFooterAnimatedIcon from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/DrawerFooterAnimatedIcon'
import { useTranslation } from 'react-i18next'

const DrawerFooter = ({ collapse }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { is_email_confirmed } = useSelector(selectAppUser)

  const isEmailConfirmed = useMemo(
    () => (typeof is_email_confirmed === 'boolean' ? is_email_confirmed : null),
    [is_email_confirmed],
  )

  const footerAnchorRef = useRef(null)

  const settingsButton = (
    <Button
      className={styles['drawer-footer__button']}
      component={Link}
      to={pathGen(ROUTES.USER_SETTINGS)}
      size={'s'}
      variant={'ghost'}
      grey
      color={'Interface-Eight'}
      startIcon={<DrawerFooterAnimatedIcon name={'settings'} />}
      title={collapse ? undefined : t('common::user_menu.settings')}
      noLabel
    />
  )

  return (
    <div
      ref={footerAnchorRef}
      className={styles['drawer-inner__grid_bottom']}
      data-drawer-footer-anchor
    >
      <Grid
        gap={8}
        wrap={false}
        flexDirection={collapse ? 'column' : 'row'}
        flexJustify={'space-between'}
        style={{ width: '100%' }}
      >
        <UserMenu
          className={styles['drawer-footer__button']}
          collapse={collapse}
          footerAnchorRef={footerAnchorRef}
        />
        <div className={styles['drawer-footer__button-wrap']}>
          <TicketsCounter
            className={styles['drawer-footer__button']}
            collapse={collapse}
          />
        </div>

        <FaqMenu
          className={styles['drawer-footer__button']}
          collapse={collapse}
          footerAnchorRef={footerAnchorRef}
        />

        <div className={styles['drawer-footer__button-wrap']}>
          {collapse ? (
            <Tooltip
              title={t('common::user_menu.settings')}
              placement={'right'}
            >
              {settingsButton}
            </Tooltip>
          ) : (
            settingsButton
          )}
          {isEmailConfirmed === false && (
            <Icon
              className={'notify-icon'}
              name={'status warning2'}
              size={'s'}
              color={'Accent-Error-Primary'}
            />
          )}
        </div>
      </Grid>
    </div>
  )
}

export default DrawerFooter

DrawerFooter.propTypes = {
  collapse: PropTypes.bool,
}
